module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 0
// module chunks = 1